import { CircularProgress, Stack } from '@mui/material';
import { useIntl } from 'react-intl';

import { TextField } from '@verantos-dev/shared-components';

export enum NameValidationStatus {
  Pending = 'pending',
  Valid = 'valid',
  Invalid = 'invalid',
  Error = 'error',
}

interface ConceptGroupNameInputProps {
  conceptGroupName: string;
  onConceptGroupNameChange: (name: string) => void;
  nameValidationStatus?: NameValidationStatus;
  nameValidationError?: string;
  isLoading?: boolean;
}

export default function ConceptGroupNameInput({
  conceptGroupName,
  onConceptGroupNameChange,
  nameValidationStatus = NameValidationStatus.Pending,
  nameValidationError,
  isLoading,
}: ConceptGroupNameInputProps) {
  const intl = useIntl();

  return (
    <Stack
      justifyContent={'flex-start'}
      gap={2}
      direction={'row'}
      width={'100%'}
      maxWidth={'840px'}
    >
      <TextField
        id="concept-group-name-input"
        displayLabel={intl.formatMessage({ id: 'conceptGroup.nameInput.label' })}
        value={conceptGroupName}
        onChange={(_, value) => onConceptGroupNameChange(value)}
        placeholder={intl.formatMessage({ id: 'conceptGroup.nameInput.placeholder' })}
        error={!!nameValidationError}
        helperText={nameValidationError}
        width={'full'}
        displayNumCharacter
        beepMaxCharacters
        maxCharacters={100}
        disabled={isLoading}
        slotProps={{
          input: {
            endAdornment:
              conceptGroupName.trim() && nameValidationStatus === NameValidationStatus.Pending ? (
                <CircularProgress size={24} />
              ) : null,
          },
        }}
      />
    </Stack>
  );
}
